import * as React from 'react'

const SvgPlayFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.25 21a.75.75 0 01-.75-.75V3.75a.75.75 0 011.126-.649l14.25 8.25a.75.75 0 010 1.298l-14.25 8.25A.748.748 0 015.25 21z"
      fill="#163250"
    />
  </svg>
)

export default SvgPlayFilledIcon
